import { AppBar, Tabs, Tab } from '@mui/material';
import { useQuery } from 'react-query';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC, useEffect, useState, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Page, PageTitleWithBack } from '../../../components';
import { getColorSchemeGeneralInfo } from '../../../fetch';
import { IColorSchemeGeneralInfo } from '../../../models';
import { GeneralInformation } from './general-information';

export const enum colorSchemePages {
  genInfo
}
interface IEditColorScheme {}

export const EditColorScheme: FC<IEditColorScheme> = () => {
  const classes = useStyles();
  const [selectedPage, setSelectedPage] = useState<colorSchemePages>(colorSchemePages.genInfo);
  const [selectedTab, setSelectedTab] = useState(window.location.pathname);
  const [isDirtyForm, setDirtyForm] = useState<boolean>(false);
  const { colorSchemeId }: { colorSchemeId: string } = useParams();
  const history = useHistory();

  const {
    isLoading: isLoadingGeneralInfo,
    data: generalInfo,
    refetch: refetchGeneralInfo
  } = useQuery<IColorSchemeGeneralInfo, Error>(
    ['color-scheme-general-info', colorSchemeId],
    () => getColorSchemeGeneralInfo(colorSchemeId),
    {
      enabled: colorSchemeId !== 'add'
    }
  );

  useEffect(() => {
    if (window.location.href.includes('general-information')) {
      setSelectedPage(colorSchemePages.genInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href, colorSchemeId]);

  const getColorSchemeId = () => {
    return colorSchemeId ? colorSchemeId : 'add';
  };

  const colorSchemeLinks = useMemo(
    () =>
      [
        {
          name: 'General Information',
          url: `/development/color-schemes/${getColorSchemeId()}/general-information`
        }
      ].filter(Boolean),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [colorSchemeId]
  );

  const showLoader = isLoadingGeneralInfo;
  const title = showLoader
    ? 'Loading...'
    : colorSchemeId === 'add'
    ? 'Add New Color Scheme'
    : `Edit: ${generalInfo?.code} `;

  return (
    <Page title={title}>
      <>
        <PageTitleWithBack
          title={title}
          backText="Back to color schemes"
          backUrl="/development/color-schemes"
        />
        {colorSchemeId !== 'add' && (
          <AppBar position="static" color="default" component="div" className={classes.tabBar}>
            <Tabs
              value={selectedTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={(_, value) => {
                if (!isDirtyForm) {
                  setSelectedTab(value);
                  history.push(value);
                } else {
                  const result = window.confirm(
                    'You have unsaved changes, are you sure you want to exit?'
                  );
                  if (result) {
                    setSelectedTab(value);
                    history.push(value);
                  } else {
                    return;
                  }
                }
              }}
              variant="scrollable"
            >
              {colorSchemeLinks.map(link => {
                return (
                  <Tab
                    value={link.url}
                    key={link.name}
                    id={`${link.name}-information`}
                    aria-controls={`${link.name}-information`}
                    label={link.name}
                  />
                );
              })}
            </Tabs>
          </AppBar>
        )}
        {selectedPage === colorSchemePages.genInfo && (
          <GeneralInformation
            setDirtyForm={setDirtyForm}
            generalInfo={generalInfo}
            isLoadingGeneralInfo={isLoadingGeneralInfo}
            refetchGeneralInfo={refetchGeneralInfo}
          />
        )}
      </>
    </Page>
  );
};

const useStyles = makeStyles(theme => ({
  tabBar: {
    marginTop: '-1rem',
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey[400]}`
  }
}));
